import { Injectable } from "@angular/core";
import { Observable ,  Subject } from "rxjs";
import { Certificate, timingSafeEqual } from "crypto";
import { TrackingManager } from "../core/tracking/tracking-manager";
import { UtilityScripts } from "../helpers/utility-scripts";
import { CourseStructureModelService } from "../core/models/course-structure-model.service";
import { DescriptorModelService } from "../core/models/descriptor-model.service";
import { NotifierService } from "./notifierService/notifier.service";
import { AppConstants } from "../core/vo/app-constants";
import validation_group from "devextreme/ui/validation_group";
import { TrackingVO } from "../core/tracking/trackingvo";
import { concatAll } from "rxjs/operators";
@Injectable()
export class CourseTimerService extends NotifierService {
	protected timerInterval: number = 5000;
	protected intSaveInterval: number = 5;
	protected intMinimumTime: number = 0;
	protected bUseTimer: boolean = false;
	protected bIsSaveInterval: boolean = false;
	protected timer: any;
	protected elt_total_time: string;
	protected session_time: string;
	protected certificateData: Date;
	protected ms_total_time: number;
	protected ms_session_time: number = 0;
	protected expected_ms_total_time: number = 0;
	protected ms_last_session_time: number = 0;
	protected start_date: Date;
	protected certificateDate: Date;
	protected bIsTotalTimeError: boolean;
	private cert_page_ords: Array<any>;
	protected underTime: boolean;
	protected minimumTime: number;
	private bCourseTimerAvailable: boolean;
	private isTimerStarted: Boolean = false;

	constructor(
		private courseStructureModel: CourseStructureModelService,
		private descriptorModel: DescriptorModelService
	) {
		super();
	}

	public initialize() {
		this.initProperties();
	}
	protected initProperties() {
		this.certificateDate = new Date();
	}
	public setTimer(saveInterval: number, minimumTime: number) {
		console.log("Course Timer Start Timer called");
		this.minimumTime = Number(minimumTime) * 60000;
		if (saveInterval >= this.intSaveInterval) {
			this.intSaveInterval = saveInterval;
			this.bIsSaveInterval = true;
		}
		if (minimumTime > 0) {
			this.intMinimumTime = minimumTime * 60000;
		}
		if (this.intMinimumTime > 0) {
			this.initLMSVars();
			if (!this.bIsTotalTimeError) {
				//this.initTimer();
			}
		}
	}
	public startTimer() {
		if (!this.bIsTotalTimeError && !this.isTimerStarted) {
			this.initTimer();
			this.isTimerStarted = true;
		}
	}
	protected initLMSVars() {
		console.log(
			"Course Timer initLMSVars ",
			TrackingManager.instance.trackingVO.elt_total_time,
			TrackingManager.instance.trackingVO.totalTime
		);
		this.elt_total_time = TrackingManager.instance.trackingVO.elt_total_time;
		if (
			TrackingManager.instance &&
			TrackingManager.instance.config.opProfile === AppConstants.DEMO_MODE
		) {
			this.ms_total_time = this.intMinimumTime;
		} else if (
			this.elt_total_time == "" ||
			this.elt_total_time == null ||
			this.elt_total_time.match(/[1-9]/) == null
		) {
			this.expected_ms_total_time = this.getCourseExpectedTime(
				TrackingManager.instance.trackingVO.bookmark
			);
			if (this.expected_ms_total_time != 0) {
				this.setValidBookmarkTime();
			} else {
				this.ms_total_time = 0;
				this.elt_total_time = "0000:00:00.00";
				this.session_time = "0000:00:00.00";
			}
		} else {
			this.ms_total_time = UtilityScripts.convertToMS(this.elt_total_time);
			this.expected_ms_total_time = this.getCourseExpectedTime(
				TrackingManager.instance.trackingVO.bookmark
			);
			if (this.ms_total_time < this.expected_ms_total_time) {
				this.setValidBookmarkTime();
			}
			this.ms_session_time = 0;
			this.session_time = "0000:00:00.00";
			if (this.ms_total_time == 0) {
				this.bIsTotalTimeError = true;
				return;
			}
		}
	}
	protected setValidBookmarkTime() {
		this.elt_total_time = UtilityScripts.convertFromMS(
			this.expected_ms_total_time
		);
		this.ms_total_time = this.expected_ms_total_time;
		this.session_time = "0000:00:00.00";
	}
	protected getCourseExpectedTime(bookmark: string): number {
		let minTimeEstimate: number = 0;
		if (bookmark) {
			let xmlStructure: any = this.courseStructureModel.structureDocXml;
			// console.log(" course Timer xmlStructure  ",xmlStructure);
			let sceneXMLList: Array<any> = [];
			let sceneID: string;
			let sceneTokens: Array<any> = bookmark.split(";");
			let sceneTokenElements: Array<any>;
			let sceneLength: number;
			for (let tok in sceneTokens) {
				if (sceneTokens[tok].indexOf(",") > 0) {
					sceneTokenElements = sceneTokens[tok].split(",");
					if (sceneTokenElements[0] == "c") {
						sceneID = sceneTokenElements[2];
						//console.log("sceneID  :",sceneID)
						let arrScenes: Array<any> = xmlStructure.querySelectorAll("scene");
						for (let j = 0; j < arrScenes.length; j++) {
							// console.log("arrScenes[j]",arrScenes[j]);
							if (arrScenes[j].getAttribute("id") == sceneID) {
								sceneXMLList.push(arrScenes[j]);
							}
						}
						//console.log("sceneXMLList length  :",sceneXMLList.length);
						if (sceneXMLList.length > 0) {
							sceneLength =
								sceneXMLList[0].getAttribute("@length") != undefined
									? Number(sceneXMLList[0].getAttribute("@length"))
									: 0;
						} else {
							sceneLength = 0;
						}
						minTimeEstimate += sceneLength;
					}
				}
			}
			minTimeEstimate *= 60000;
		}
		// console.log("minTimeEstimate ",minTimeEstimate);
		return minTimeEstimate;
	}
	protected initTimer() {
		this._notifier.next({ totalTime: this.ms_total_time });
		if (
			this.ms_total_time < this.intMinimumTime &&
			TrackingManager.instance.trackingVO.lessonStatus !=
				TrackingManager.instance.config.completedVal
		) {
			let _owner = this;
			this.timer = setInterval(function () {
				_owner.handleTimerReached();
			}, this.timerInterval);
		} else if (
			this.ms_total_time >= this.intMinimumTime ||
			TrackingManager.instance.trackingVO.lessonStatus ==
				TrackingManager.instance.config.completedVal
		) {
			this._notifier.next({ type: "demo", totalTime: this.intMinimumTime });
		}
	}
	protected handleTimerReached() {
		// console.log("handleTimerReached ");
		this.updateTime();
	}
	protected updateTime() {
		console.log("update Tiem  elt_total_time", this.elt_total_time);
		this.ms_session_time += this.timerInterval;
		this.ms_total_time += this.timerInterval;
		this.elt_total_time = UtilityScripts.convertFromMS(this.ms_total_time);
		this.session_time = UtilityScripts.convertFromMS(this.ms_session_time);
		this._notifier.next({ totalTime: this.ms_total_time });
		// console.log("this.elt_total_time ",this.elt_total_time);
		// console.log("this.session_time ",this.session_time);

		if (this.ms_total_time >= this.intMinimumTime && this.underTime == true) {
			this.stopOverTime();
		}
		if (this.ms_total_time >= this.intMinimumTime) {
			this.disposeTimer();
			this._notifier.next("complete");
		}
	}

	protected stopOverTime() {
		this.underTime = false;
		let underTimeMetHeader: string =
			this.descriptorModel.getDescriptorTextById("timerMinMetHeader");
		let underTimeMetBody: string =
			this.descriptorModel.getDescriptorTextById("timerMinMetBody");
		let underTimeMetFooter: string =
			this.descriptorModel.getDescriptorTextById("timerMinMetFooter");
		let continue_str: string = this.descriptorModel.getDescriptorTextById(
			"timerMinMetContinue"
		);
		let certificate_str: string = this.descriptorModel.getDescriptorTextById(
			"timerMinMetCertificate"
		);
	}

	public startOvertime(page_ords: Array<any>) {
		this.cert_page_ords = page_ords.toString().split(",");
		this.underTime = true;

		let utHeader: string = this.descriptorModel.getDescriptorTextById(
			"timerUndertimeHeader"
		);
		let utBody: string =
			this.descriptorModel.getDescriptorTextById("timerUTdesc1");
		utBody += UtilityScripts.getClockFormat(this.minimumTime);
		utBody += this.descriptorModel.getDescriptorTextById("timerUTdesc2");
		let totalTime_str =
			this.descriptorModel.getDescriptorTextById("timerTotalLabel");
		let requiredTime_str =
			this.descriptorModel.getDescriptorTextById("timerMinimumLabel");

		utBody +=
			"<br><br><p><b>" +
			totalTime_str +
			"        </b> <b>" +
			UtilityScripts.getClockFormat(this.totalTimeInt) +
			"</b></p>";
		utBody +=
			"<p><b>" +
			requiredTime_str +
			"  " +
			UtilityScripts.getClockFormat(this.minimumTime) +
			"</b></p>";
		let continue_str: string = this.descriptorModel.getDescriptorTextById(
			"timerMinMetContinue"
		);
	}

	public isTimeMet(): boolean {
		if (this.intMinimumTime > 0) {
			return this.ms_total_time >= this.intMinimumTime;
		} else {
			return false;
		}
	}
	public calculateSessionTime(): string {
		let startTime: number = this.certificateDate.getTime();
		let currentDate: Date = new Date();
		let currentTime: number = currentDate.getTime();
		let sessTime: number = currentTime - startTime;
		return UtilityScripts.convertFromMS(sessTime);
	}
	public get sessionTimeString() {
		if (this.session_time == "" || this.session_time == null) {
			return this.calculateSessionTime();
		} else {
			return this.session_time;
		}
	}
	public get totalTimeString(): string {
		return this.elt_total_time;
	}
	public get totalTimeInt(): number {
		return this.ms_total_time;
	}
	public set totalTimeInt(val: number) {
		this.ms_total_time = val;
	}

	public get minimumTimeint(): number {
		return this.intMinimumTime;
	}
	public get bUnderTime(): boolean {
		return this.underTime;
	}
	public disposeMe() {
		this.disposeTimer();
	}
	public disposeTimer() {
		console.log("Timer Dispose");
		clearInterval(this.timer);
		this.timer = null;
	}
	public get Timer() {
		return this.timer;
	}
	public isTimeChanged(): boolean {
		if (!this.bUnderTime) {
			return true;
		}
		if (this.ms_session_time > this.ms_last_session_time) {
			this.ms_last_session_time = this.ms_session_time;
			return true;
		} else {
			return false;
		}
		// return true;
	}
	public get certpageOrds(): Array<any> {
		return this.cert_page_ords;
	}
	public set isCourseTimerAvailable(val: boolean) {
		this.bCourseTimerAvailable = val;
		this._notifier.next({ available: this.bCourseTimerAvailable });
	}
	public get isCourseTimerAvailable(): boolean {
		return this.bCourseTimerAvailable;
	}
}
